<template>
  <div id="contenedor-eliminar-oficio-autorizacion">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Oficio </v-card-title>
      <v-card-text>
        <span
        v-if="oficioAutorizacionEliminar.detalles.length > 0"
        class="error--text"
          >
          No se puede eliminar oficio, tiene recursos relacionados
        </span>
        <span
        v-if="oficioAutorizacionEliminar.detalles.length === 0"
        class="secondary--text"> ¿Desea eliminar el oficio? </span>
        <v-divider></v-divider>
        <v-row>
        <span class="font-weight-bold">
            {{oficioAutorizacionEliminar.numero}}
            ({{ new Date(`${oficioAutorizacionEliminar.fecha} 00:00:0`).toLocaleDateString() }})
        </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button v-if="oficioAutorizacionEliminar.detalles.length === 0"
          @click="mixEliminarOficio"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import MixOficioAutorizacion from './mixOficiosAutorizacion';

export default {
  name: 'EliminarOficioAutorizacion',
  mixins: [MixOficioAutorizacion],
  props: {
    oficioAutorizacionEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
